import { ShellFrame } from "../shell/ShellFrame";
import { NotFoundState } from "../shell/states";

/**
 * The root `/` (and any unmatched path). The widget's only real entry is `/v/:venueSlug`; everything
 * else renders a non-indexable not-found shell rather than a blank or a leaked app skeleton. Reinforced
 * by the strict CSP + `X-Robots-Tag: noindex` on non-`/v/*` paths (public/_headers).
 */
export function NotFound() {
  return (
    <ShellFrame>
      <NotFoundState />
    </ShellFrame>
  );
}
